export function getAllDepartmentPositions(department) {
    return [...(department.positions || []), ...(department.archivedPositions || [])];
}
//# sourceMappingURL=department.util.js.map